import { callApiToServer } from "../callApi";

export async function deleteSocialWorker(
  authtoken,
  deleteWorkerObject,
  userId
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      userId: userId,
      programId: deleteWorkerObject.program_id,
    });

    let endUrl = "v1/auth/delete-social-worker";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
